import { useCallback, useState } from 'react';

const useCbtVenueScreen = () => {
  const [showCbtVenueSelection, setShowCbtVenueSelection] = useState(false);

  const openCbtVenueSelection = useCallback(() => {
    setShowCbtVenueSelection(true);
  }, []);

  const closeCbtVenueSelection = useCallback(() => {
    setShowCbtVenueSelection(false);
  }, []);

  return {
    showCbtVenueSelection,
    openCbtVenueSelection,
    closeCbtVenueSelection
  };
};

export default useCbtVenueScreen;
